module.exports = __webpack_public_path__ + "static/hero-image-mobile_b-465bc53354e8a484e5da9202e002148c.webp";